import { connect } from 'react-redux';

import { RootState } from '../../../../reducers';
import FileInput from '../../FileInput/FileInput';
import UploadedFilesStatus from '../../FileUpload/UploadedFilesStatus';
import MissingRequiredDocWarning from '../../MissingRequiredDocWarning/MissingRequiredDocWarning';
import { useDocPresentStatus } from '../../MissingRequiredDocWarning/MissingRequiredDocWarning.hook';
import { documentTypes } from '../../TradingHistory.helpers';
import thstyles from '../../TradingHistory.module.css';
import styles from '../OptionalStatement.module.css';

const mapStateToProps = (state: RootState) => {
    return {
        missingDocs: state?.tradingHistory?.missing
    };
};

const CompanyAccount = ({
    isOptional,
    missingDocs
}: {
    isOptional: boolean;
    missingDocs: [];
}) => {
    const isCompanyAccountMissing = useDocPresentStatus(
        missingDocs,
        'company_accounts'
    );
    return (
        <>
            <div className={thstyles.headerSection}>
                <h3 className={thstyles.title}>Latest company accounts</h3>
                {isCompanyAccountMissing && (
                    <MissingRequiredDocWarning dataTestId="company-account-warning" />
                )}
            </div>
            <div
                className={styles.CurrentManagementSection}
                data-testid="company-account">
                <div className={styles.descriptionContainer}>
                    <p>Make sure they:</p>
                    <ul>
                        <li>
                            Include the P&L page and latest balance sheet broken
                            down by items.{' '}
                            <a
                                href="https://effective-accounting.co.uk/blog/what-is-included-in-my-company-accounts/"
                                target="_blank"
                                rel="noopener noreferrer">
                                Learn more
                            </a>
                        </li>
                        <li>Are not draft versions.</li>
                        <li>Are PDFs.</li>
                    </ul>
                </div>
                <FileInput
                    documentType={documentTypes.company_accounts}
                    buttonText="Upload accounts"
                    isOptional={isOptional}
                />
            </div>
            <UploadedFilesStatus
                documentType={documentTypes.company_accounts}
            />
        </>
    );
};

export default connect(mapStateToProps)(CompanyAccount);
